<template>
  <v-container background pa-3 fluid>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-layout row wrap style="margin-left:15px;">
          <v-flex xs12 style="margin-top:15px;">
            <p style=" font-size:20px;padding: 10px 0;">{{ $t("WithholdingTaxCertificate") }}</p>
          </v-flex>
          <v-flex md2 xs12 px-1>
            <v-select v-model="year" :items="years" :label="$t('Taxyear')" item-text="name" item-value="name"></v-select>
          </v-flex>
          <v-flex md2 xs12 px-1>
            <v-select required :items="branch_items" :label="$t('branch')" item-text="name" item-value="code" v-model="branch" hide-details @input="getProfileDepartmentList()" />
          </v-flex>
          <!-- <v-flex md2 sm6 xs12 px-1>
            <v-select
              required
              :items="department_items"
              :label="$t('Department')"
              item-text="name"
              item-value="code"
              v-model="department"
              hide-details
            />
          </v-flex>-->
        </v-layout>
        <v-layout row wrap style="margin-left:15px;">
          <v-flex lg2 md4 sm12 xs12 px-1>
            <v-btn block color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-file-download</v-icon>
              <span>{{ $t("Loaddata") }}</span>
            </v-btn>
          </v-flex>
          <v-flex lg2 md4 sm12 xs12 px-1>
            <v-btn block color="primary" @click="downloadAllPDF()">
              <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
              <span>Download PDF</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="tabledata == true" style="padding-top:20px">
          <v-layout row wrap style="margin-left:15px;">
            <v-btn dark color="blue-grey darken-2" v-if="buttonlist == 1" @click="checkbutton(0, 'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(0, 'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark color="blue-grey darken-2" v-if="buttonlist == 0" @click="checkbutton(1, 'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(1, 'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-layout>
          <v-flex md12 sm12 xs12>
            <v-layout row wrap style="margin-top:10px;margin-left:10px">
              <v-flex lg2 md6 sm6 xs12>
                <!-- <v-layout row wrap v-if="buttonlist == 1 ">
                  <v-btn block color="primary" @click="viewperson()">
                    <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                    <span>{{$t('Exportpdf')}}</span>
                  </v-btn>
                </v-layout>-->
              </v-flex>
              <v-flex lg10 md6 sm6 xs12 text-lg-right text-md-right text-sm-right text-xs-right style="font-size:16px" v-if="buttonlist == 0">
                <p>{{ $t("Page") + " : " }}{{ pageActive }}/{{ newarrayemp.length }}</p>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!showLoading">
              <!-- List -->
              <v-layout row wrap v-if="buttonlist == 0">
                <v-container fluid pt-3 style="border-right:0px;border-left:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
                      <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                      <v-card v-for="(item, i) in arraydetails" :key="i" style="padding: 10px">
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content">&nbsp;({{ item.emp_code }})</span>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content">&nbsp;({{ item.emp_code }})</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{ $t("Taxpaymentdate") + " : " }}
                                  <span>{{ selectedformatDates(item.payDate) }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg10 md12 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                        <span class="coco-list-label-text">
                                          {{ $t("Address") + " : " }}
                                          <span>{{ item.address }}</span>
                                        </span>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex lg10 md12 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex xs12 class="hidden-sm-and-up">
                                        <span class="coco-list-label-text">
                                          {{ $t("Address") + " : " }}
                                          <span>{{ item.address }}</span>
                                        </span>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{ $t("Salary") + " : " }}
                                  <span class="text-salary">{{ formatNumber(item.earning) }} &nbsp;{{ $t("baht") }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg6 md6 sm6 xs12 class="hidden-xs-only content">
                                <span class="coco-list-label-text">
                                  {{ $t("TaxID") + " : " }}
                                  <span>{{ item.id_card }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{ $t("Tax") + " : " }}
                                  <span class="text-tax">{{ formatNumber(item.tax_pay) }}</span>
                                  &nbsp;{{ $t("baht") }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex offset-md10 offset-sm8 lg2 md2 sm4 xs12>
                            <v-btn block color="primary" @click="downloadSinglePDF(item)">
                              <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                              <span>{{ $t("Exportpdf") }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                      <v-card v-for="(item, i) in arraydetails" :key="i" style="padding: 10px">
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content">({{ item.emp_code }})</span>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                <span>{{ item.emp_name }}</span>
                                <span class="coco-list-label-text content">({{ item.emp_code }})</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{ $t("Taxpaymentdate") + " : " }}
                                  <span>{{ selectedformatDates(item.payDate) }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs6>
                            <v-layout row wrap>
                              <v-flex lg10 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                    <span class="coco-list-label-text">
                                      {{ $t("Address") + " : " }}
                                      <span>{{ item.address }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg10 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{ $t("Address") + " : " }}
                                      <span>{{ item.address }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{ $t("Salary") + " : " }}
                                  <span class="text-salary">{{ formatNumber(item.earning) }} &nbsp;{{ $t("baht") }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{ $t("TaxID") + " : " }}
                                      <span>{{ item.id_card }}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{ $t("Tax") + " : " }}
                                  <span class="text-tax">{{ formatNumber(item.tax_pay) }}</span>
                                  &nbsp;{{ $t("baht") }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex offset-md10 offset-sm8 lg2 md2 sm4 xs12>
                            <v-btn block color="primary" @click="downloadSinglePDF(item)">
                              <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                              <span>{{ $t("Exportpdf") }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- ปุ่มกดเปลี่ยนหน้า -->
                <v-layout row wrap align-center justify-center style="margin-top:20px">
                  <v-pagination v-model="pageActive" :length="totalPages" circle @input="getdataList(pageActive)"></v-pagination>
                </v-layout>
              </v-layout>
              <!-- table -->
              <v-layout v-if="buttonlist == 1">
                <v-flex xs12 class="scroll-able" style="margin-top:10px">
                  <v-data-table id="table_detail" :headers="headers0" :items="newjson.details" item-key="emp_name" style="font-size:16px">
                    <template slot="items" slot-scope="props">
                      <tr style="text-align:center;">
                        <!-- <td>
                          <v-checkbox
                            v-model="props.selected"
                            itemid=" props.item.emp_code"
                            hide-details
                          ></v-checkbox>
                        </td>-->
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.id_card }}</td>
                        <td>{{ props.item.emp_name }}</td>
                        <td>{{ props.item.address }}</td>
                        <td>{{ selectedformatDates(props.item.payDate) }}</td>
                        <td>{{ formatNumber(props.item.earning) }}</td>
                        <td>{{ formatNumber(props.item.tax_pay) }}</td>
                        <td>
                          <v-icon color="#067ce2" dark @click="viewpdf(props.item.emp_code)">fa-file-pdf</v-icon>
                        </td>
                      </tr>
                    </template>
                    <!-- <template v-slot:item.action="{ item }">
                      <v-icon small class="mr-2" color="#067ce2"  @click="viewpdf(item.emp_code)">print</v-icon>
                    </template> -->
                    <template slot="footer">
                      <tr style="text-align:center">
                        <td colspan="5">รวมยอดเงินได้และภาษีนำส่งทั้งหมด</td>
                        <td>{{ formatNumber(totalIncome > 0 ? totalIncome : newjson.total_earning) }}</td>
                        <td colspan="2">{{ formatNumber(totalTax > 0 ? totalTax : newjson.total_tax) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-layout>

            <!-- แสดงเงินเดือนและภาษีรวมทั้งหมด  -->
            <v-layout row wrap style="margin-top:5px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">{{ $t("Totallist") + " : " }}&nbsp;&nbsp;{{ newjson.details.length }}&nbsp;&nbsp; {{ $t("List") }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="margin-top:5px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">
                  {{ $t("Totalsalary") + " : " }}&nbsp;&nbsp;
                  <span class="text-salary">{{ formatNumber(totalIncome > 0 ? totalIncome : newjson.total_earning) }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="margin-top:5px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">
                  {{ $t("Totaltax") + " : " }}&nbsp;&nbsp;
                  <span class="text-tax">{{ formatNumber(totalTax > 0 ? totalTax : newjson.total_tax) }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading_detail" persistent width="350">
        <v-card>
          <v-card-text>
            Processing... <span v-if="progress > 0">{{ progress }}%</span>
            <v-progress-linear :value="progress" max="100" v-if="progress > 0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_loading_WHT" persistent width="350">
        <v-card>
          <v-card-text>
            กำลังสร้าง PDF...
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
      {{ snackmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import numeral from "numeral";
import Utils from "@/utils/";
import { constants } from "crypto";
import $ from "jquery";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import JSZip from "jszip";
export default {
  data: () => ({
    years: [],
    year: "",
    branch: "",
    branch_items: [],
    department: "",
    department_items: [],
    tabledata: false,
    dialog_loading_detail: false,
    progress: 0,
    json: {
      details: [],
      from_date: "",
      to_date: "",
      total_earning: 0,
      total_tax: 0,
    },
    newjson: {},
    buttonlist: 0,
    //singleSelect: false,
    selected: [],
    selected0: [],
    //test
    i: 0,
    headers: [
      { text: "ลำดับที่", value: "ลำดับที่", width: "5%", align: "center" },
      {
        text: "เลขประจำตัวผู้เสียภาษีอากร",
        value: "เลขประจำตัวผู้เสียภาษีอากร",
        width: "20%",
        align: "center",
      },
      {
        text: "ชื่อผู้มีเงินได้",
        value: "ชื่อผู้มีเงินได้",
        width: "20%",
        align: "center",
      },
      {
        text: "ที่อยู่ของผู้มีเงินได้",
        value: "ที่อยู่ของผู้มีเงินได้",
        width: "20%",
        align: "center",
      },
      {
        text: "วัน เดือน ปี ที่จ่าย",
        value: "วัน เดือน ปี ที่จ่าย",
        width: "10%",
        align: "center",
      },
      {
        text: "จำนวนเงินได้ที่จ่าย",
        value: "จำนวนเงินได้ที่จ่าย",
        width: "10%",
        align: "center",
      },
      {
        text: "จำนวนเงินภาษีที่นำส่ง",
        value: "จำนวนเงินภาษีที่นำส่ง",
        width: "10%",
        align: "center",
      },
      {
        text: "",
        value: "",
        width: "5%",
        align: "center",
      },
    ],
    pageActive: 1,
    totalPages: 0,
    //perPageItems: ["5", "10", "15", "20", "30", "50"],
    //perPage: "5",
    newarrayemp: [],
    arraydetails: [],
    emp_code: "",
    doc_ref: "",
    snackbarcolor: "red",
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    detail_count: 0,
    data_by_branch: [],
    totalIncome: 0,
    totalTax: 0,
    showdateend: "",
    zipLinks: [],
    zipChunks: [],
    dialog_loading_WHT: false,
    taxpayer_number: "",
    companyName: "",
    companyhouse_no: "",
    companysubdistrict_subarea: "",
    companydistrict_area: "",
    companyprovince: "",
    companypostcode: "",
    tax: 0,
    texttax: "",
  }),

  components: {
    DeleteDialog,
  },
  computed: {
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    ...mapState("filter", ["Branch_List", "Department_List", "Position_List", "Errormsg", "SelectBranch", "SelectDepartment", "SelectPosition", "SearchData"]),
    //test
    headers0() {
      return this.headers.map((header) => Object.assign({}, header, { fixed: false }));
    },
  },
  created: async function() {
    await this.createyear();
    await this.commitSetToolbar({ patternTool: "0" });
    await this.getProfileBranchList();
    await this.loadCompanyData();

    //await this.getdataList();
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 10;
      var endyear = parseInt(curryears);
      // console.log("curryears", curryears);
      // console.log("startyear", startyear);
      // console.log("endyear", endyear);
      for (var d = endyear; d >= startyear; d--) {
        this.years.push({ name: d });
      }
      // console.log(curryears);
      this.year = parseInt(curryears);
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
          // console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then((res) => {
          this.department_items = res.data;
          // console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          // console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = [];
            this.branch_items.push({ code: "", name: "ทั้งหมด" });

            res.data.content.forEach((element) => {
              this.branch_items.push(element);
            });
            // console.log("eeee", this.branch_items);
          } else {
            // console.log("ddddd");
            // console.log(this.Employee_List);
            this.Employee_List.forEach((emp) => {
              this.Employee_list.push(emp);
            });
            // console.log(this.Employee_list);
          }
        })
        .catch((err) => {
          console.log(err);

          console.log("ddddd");
          this.Employee_List.forEach((emp) => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    thousandSep(nStr) {
      //nStr = nStr.toFixed(4);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    groupBy(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    formatNumber(val) {
      var result = numeral(val).format("0,0.00");
      //console.log("string: ", string)
      return result;
    },
    process() {
      // console.log(this.year);
      this.detail_count = 0;
      if (this.year == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกปี";
        this.snackbarcolor = "error";
      } else {
        let v = this;
        this.dialog_loading_detail = true;
        DocumentService.getTaxDetailByYearAllEmpCount(this.year, this.branch, this.department)
          .then((res) => {
            // console.log(res.data);
            this.detail_count = res.data;
            this.processTaxDetail();
          })
          .catch((err) => {
            console.log(err);
            this.dialog_loading_detail = false;
          });
      }
    },
    async processTaxDetail() {
      this.progress = 0;
      var v = this;
      const size = 100;
      const totalChunks = Math.ceil(this.detail_count / size);
      console.log("Total Chunks: ", totalChunks);
      let completedChunks = 0;
      this.dialog_loading_detail = true;
      var dataWaitList = [];
      this.json = {
        details: [],
        from_date: "",
        to_date: "",
        total_earning: 0,
        total_tax: 0,
        BranchDetails: [],
      };
      for (let i = 0; i < totalChunks; i++) {
        // console.log("Processing chunk", i);
        try {
          const res = await DocumentService.getTaxDetailByYearAllEmpPage(this.year, this.branch, this.department, i, size);
          console.log("Batch import successful", res);
          res.data.details.forEach((element) => {
            v.json.details.push(element);
          });
          this.json.from_date = res.data.from_date;
          this.json.to_date = res.data.to_date;
          this.json.total_earning += parseFloat(res.data.total_earning);
          this.json.total_tax += parseFloat(res.data.total_tax);

          // ประมวลผล BranchDetails (รวมทุก chunk)

          if (res.data.BranchDetails && res.data.BranchDetails.length > 0) {
            this.json.BranchDetails = res.data.BranchDetails;
          }
          console.log("this.json.BranchDetails", this.json.BranchDetails);

          completedChunks++;
          this.updateProgressBar(completedChunks, totalChunks);
        } catch (err) {
          console.error(err);
          this.dialog_loading_detail = false;
          this.snackbar = true;
          this.errmsg = err.message;
          break; // Stop processing if there is an error
        }
      }
      if (completedChunks === totalChunks) {
        // console.log("All chunks processed successfully");
        console.log("this.json", this.json);

        // ประมวลผล BranchDetails หลังจากโหลดครบทุก chunk
        if (this.json.BranchDetails && this.json.BranchDetails.length > 0) {
          var branchDetailsJson = [];

          this.json.BranchDetails.forEach((element) => {
            try {
              branchDetailsJson.push(JSON.parse(element));
            } catch (e) {
              console.error("Error parsing branch detail:", e);
            }
          });

          console.log("branchDetailsJson", branchDetailsJson);

          if (branchDetailsJson.length > 0) {
            var resultBranch = this.aggregateData(branchDetailsJson);
            this.data_by_branch = resultBranch;
            // console.log('data_by_branch', resultBranch);
          }
        }

        this.display_table();
      }
    },
    updateProgressBar(completedChunks, totalChunks) {
      this.progress = Math.round((completedChunks / totalChunks) * 100);
    },
    async display_table() {
      var v = this;
      this.arraydetails = [];
      this.tabledata = true;
      // console.log("this.json: ", this.json);
      //**new array **//
      this.newjson.from_date = this.json.from_date;
      this.newjson.to_date = this.json.to_date;
      this.newjson.total_earning = this.json.total_earning;
      this.newjson.total_tax = this.json.total_tax;
      this.newjson.details = [];
      this.showdateend = this.json.to_date; // เก็บวันที่สิ้นสุด
      var sumearning = 0;
      var sumtax_pay = 0;
      var sumsocial_pay = 0;

      // ถ้ามี data_by_branch และเลือกสาขาเฉพาะ ใช้ข้อมูลจาก data_by_branch
      if (this.data_by_branch.length > 0 && this.branch != "" && this.branch != null) {
        const selectedBranch = this.data_by_branch.find((b) => b.branch_code === this.branch);

        if (selectedBranch && selectedBranch.details) {
          selectedBranch.details.forEach((detail) => {
            this.newjson.details.push({
              emp_code: detail.emp_code,
              id_card: detail.idcard,
              emp_name: detail.emp_name,
              payDate: this.newjson.to_date,
              address: detail.address,
              social_pay: 0,
              earning: detail.earning || detail.total_income || 0,
              tax_pay: detail.tax_pay || detail.total_tax || 0,
              total_income1: detail.total_income1 || 0,
              total_income2: detail.total_income2 || 0,
              total_tax1: detail.total_tax1 || 0,
              total_tax2: detail.total_tax2 || 0,
              total_balance: detail.total_balance || 0,
              tax_number: detail.tax_number || "",
            });
          });
        }
      } else {
        // ถ้าเลือก "ทั้งหมด" รวมข้อมูลจากทุกสาขาใน data_by_branch
        if (this.data_by_branch.length > 0) {
          // สร้าง map เพื่อรวมข้อมูลพนักงานที่ซ้ำกันจากหลายสาขา
          const empMap = {};

          this.data_by_branch.forEach((branch) => {
            if (branch.details && branch.details.length > 0) {
              branch.details.forEach((detail) => {
                if (!empMap[detail.emp_code]) {
                  empMap[detail.emp_code] = {
                    emp_code: detail.emp_code,
                    id_card: detail.idcard,
                    emp_name: detail.emp_name,
                    payDate: this.newjson.to_date,
                    address: detail.address,
                    social_pay: 0,
                    earning: 0,
                    tax_pay: 0,
                    total_income1: 0,
                    total_income2: 0,
                    total_tax1: 0,
                    total_tax2: 0,
                    total_balance: 0,
                    tax_number: detail.tax_number || "",
                  };
                }

                // รวมข้อมูล
                empMap[detail.emp_code].earning += detail.earning || detail.total_income || 0;
                empMap[detail.emp_code].tax_pay += detail.tax_pay || detail.total_tax || 0;
                empMap[detail.emp_code].total_income1 += detail.total_income1 || 0;
                empMap[detail.emp_code].total_income2 += detail.total_income2 || 0;
                empMap[detail.emp_code].total_tax1 += detail.total_tax1 || 0;
                empMap[detail.emp_code].total_tax2 += detail.total_tax2 || 0;
                empMap[detail.emp_code].total_balance += detail.total_balance || 0;
              });
            }
          });

          // แปลง map เป็น array
          Object.values(empMap).forEach((emp) => {
            this.newjson.details.push(emp);
          });
        } else {
          // ถ้าไม่มี data_by_branch ใช้วิธีเดิม
          const unique = this.groupBy(this.json.details, "code");
          let keys = "";
          let index = 0;
          for (var key in unique) {
            let emp_code = "";
            let id_card = "";
            let emp_name = "";
            let payDate = "";
            let address = "";
            let j = 0;
            sumearning = 0;
            sumtax_pay = 0;
            sumsocial_pay = 0;
            unique[key].forEach((element) => {
              emp_code = element.code;
              id_card = element.idCard;
              emp_name = element.nameTitle + " " + element.firstName + " " + element.lastName;
              payDate = this.newjson.to_date;
              address = element.address;
              sumsocial_pay += element.deductSS;
              sumearning += element.totalEarning;
              sumtax_pay += element.deduct_tax;
              j++;
            });
            this.newjson.details.push({
              emp_code: emp_code,
              id_card: id_card,
              emp_name: emp_name,
              payDate: payDate,
              address: address,
              social_pay: sumsocial_pay,
              earning: sumearning,
              tax_pay: sumtax_pay,
              total_income1: 0,
              total_income2: 0,
              total_tax1: 0,
              total_tax2: 0,
              total_balance: sumtax_pay,
              tax_number: "",
            });
          }
        }
      }
      // console.log("json: ", this.json);
      // console.log("new json: ", this.newjson);
      this.checkbutton(0, "display");

      //console.log("totalpages: ", this.totalPages);
      /*set data pagination*/
      var array = [];
      this.newarrayemp = [];
      var k = 0;
      var i = 1;
      for (k = 0; k < this.newjson.details.length; k++) {
        // console.log("k", this.newjson.details[k]);
        if (i <= 5) {
          array.push(this.newjson.details[k]);
          // console.log("num: " + i);
        }
        if (i > 5) {
          this.newarrayemp.push(array);
          i = 1;
          array = [];
          array.push(this.newjson.details[k]);
          // console.log("iii", this.newarrayemp);
          //this.perPage = i;
        }
        if (k == this.newjson.details.length - 1) {
          this.newarrayemp.push(array);
          // console.log("ffff", this.newarrayemp);
        }
        i = i + 1;
      }
      // console.log("newarrayemp: ", this.newarrayemp);
      this.totalPages = this.newarrayemp.length;
      /*close set data pagination*/
      for (var i = 0; i < this.newarrayemp.length; i++) {
        if (0 == i) {
          this.newarrayemp[i].forEach((element) => {
            // console.log("element: ", element);
            this.arraydetails.push(element);
          });
        }
      }
      // console.log("arraydetails: ", this.arraydetails);

      // คำนวณยอดรวมตามสาขาที่เลือก (เรียกตอนท้าย)
      this.calculateTotalsByBranch();

      // คำนวณยอดรวมจริงจากข้อมูลที่แสดง
      this.calculateTotalsFromDetails();

      // โหลดข้อมูลบริษัท

      this.dialog_loading_detail = false;
    },
    async loadCompanyData() {
      try {
        const tmpResult = await SettingService.getDataCompany();
        // console.log(tmpResult);
        this.companyName = tmpResult.data.content[0].companyname;
        this.companyhouse_no = tmpResult.data.content[0].house_no;
        this.companysubdistrict_subarea = tmpResult.data.content[0].subdistrict_subarea;
        this.companydistrict_area = tmpResult.data.content[0].district_area;
        this.companyprovince = tmpResult.data.content[0].province;
        this.companypostcode = tmpResult.data.content[0].postcode;
        this.taxpayer_number = tmpResult.data.content[0].taxpayer_number;
      } catch (err) {
        console.error("Error loading company data:", err);
      }
    },
    aggregateData(data) {
      const result = [];

      data.forEach((monthlyData) => {
        monthlyData.forEach((branch) => {
          let branchResult = result.find((b) => b.branch_code === branch.branch_code);

          if (!branchResult) {
            branchResult = {
              branch_code: branch.branch_code,
              branch_name: branch.branch_name,
              details: [],
            };
            result.push(branchResult);
          }

          branch.details.forEach((detail) => {
            let detailResult = branchResult.details.find((d) => d.emp_code === detail.emp_code);

            if (!detailResult) {
              detailResult = {
                emp_code: detail.emp_code,
                emp_name: detail.emp_name,
                prefix: detail.prefix || "",
                firstName: detail.firstName || "",
                lastName: detail.lastName || "",
                idcard: detail.idcard || "",
                address: detail.address || "",
                total_income: 0,
                total_income1: 0,
                total_income2: 0,
                total_tax: 0,
                total_tax1: 0,
                total_tax2: 0,
                total_balance: 0,
                earning: 0,
                tax_pay: 0,
              };
              branchResult.details.push(detailResult);
            }

            detail.total_income = parseFloat(detail.total_income) || 0;
            detail.total_income1 = parseFloat(detail.total_income1) || 0;
            detail.total_income2 = parseFloat(detail.total_income2) || 0;
            detail.total_tax = parseFloat(detail.total_tax) || 0;
            detail.total_tax1 = parseFloat(detail.total_tax1) || 0;
            detail.total_tax2 = parseFloat(detail.total_tax2) || 0;
            detail.total_balance = parseFloat(detail.total_balance) || 0;

            // รวมข้อมูล
            detailResult.total_income += detail.total_income || 0;
            detailResult.total_income1 += detail.total_income1 || 0;
            detailResult.total_income2 += detail.total_income2 || 0;
            detailResult.total_tax += detail.total_tax || 0;
            detailResult.total_tax1 += detail.total_tax1 || 0;
            detailResult.total_tax2 += detail.total_tax2 || 0;
            detailResult.total_balance += detail.total_balance || 0;
            detailResult.earning += detail.total_income || 0;
            detailResult.tax_pay += detail.total_tax || 0;

        
          });
        });
      });

      return result;
    },
    calculateTotalsByBranch() {
      this.totalIncome = 0;
      this.totalTax = 0;

      // console.log('Calculating totals for branch:', this.branch);
      // console.log('data_by_branch:', this.data_by_branch);

      if (this.branch == "" || this.branch == null) {
        // ถ้าเลือก "ทั้งหมด" ใช้ค่าจาก newjson
        this.totalIncome = this.newjson.total_earning || 0;
        this.totalTax = this.newjson.total_tax || 0;
      } else {
        // ถ้าเลือกสาขาเฉพาะ คำนวณจาก data_by_branch
        const selectedBranch = this.data_by_branch.find((b) => b.branch_code === this.branch);

        if (selectedBranch && selectedBranch.details) {
          selectedBranch.details.forEach((detail) => {
            this.totalIncome += detail.earning || detail.total_earning || detail.total_income || 0;
            this.totalTax += detail.tax_pay || detail.total_tax_pay || detail.total_tax || 0;
          });
        } else {
          // ถ้าหาสาขาไม่เจอ ใช้ค่าเดิม
          this.totalIncome = this.newjson.total_earning || 0;
          this.totalTax = this.newjson.total_tax || 0;
        }
      }

      // console.log('Calculated Total Income:', this.totalIncome);
      // console.log('Calculated Total Tax:', this.totalTax);
    },
    calculateTotalsFromDetails() {
      // คำนวณยอดรวมจริงจากข้อมูลที่อยู่ใน newjson.details
      this.totalIncome = 0;
      this.totalTax = 0;

      if (this.newjson.details && this.newjson.details.length > 0) {
        this.newjson.details.forEach(detail => {
          this.totalIncome += detail.earning || 0;
          this.totalTax += detail.tax_pay || 0;
        });
      }

      // อัพเดท newjson ด้วย
      this.newjson.total_earning = this.totalIncome;
      this.newjson.total_tax = this.totalTax;

      console.log('Calculated from details - Total Income:', this.totalIncome);
      console.log('Calculated from details - Total Tax:', this.totalTax);
    },
    getdataList(pageOfItems) {
      this.arraydetails = [];
      for (var i = 0; i < this.newarrayemp.length; i++) {
        // console.log("i: ", i);
        if (pageOfItems - 1 == i) {
          // console.log("pageOfItems: ", pageOfItems - 1);
          this.newarrayemp[i].forEach((element) => {
            // console.log("element: ", element);
            this.arraydetails.push(element);
          });
        }
      }
      // console.log("arraydetails: ", this.arraydetails);
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [day, month, year].join("/");
    },
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
        console.log("buttonlist", this.buttonlist);
      }
    },
    viewpdf(emp_code) {
      if (this.branch == "") {
        window.open("#/WHTC/" + this.year + "/" + emp_code + "/ALL", "_blank");
      } else {
        window.open("#/WHTC/" + this.year + "/" + emp_code + "/" + this.branch, "_blank");
      }
    },
    viewperson() {
      console.log("selected: ", this.selected0);
      let i = 0;
      this.doc_ref = "";
      this.selected0.forEach((element) => {
        i++;
        if (i != this.selected0.length) {
          this.doc_ref += element.emp_code + ",";
        } else {
          this.doc_ref += element.emp_code;
        }
      });
      window.open("#/WHTCALL/" + this.year + "/" + this.doc_ref + "/" + this.branch, "_blank");
      console.log("doc_ref: ", this.doc_ref);
      // var checkedValues = $('input[class="checkit"]:checked')
      //   .map(function() {
      //     return this.value;
      //   console.log("checkedValues: ",checkedValues);
      //   })
      //   .get();
      // if (checkedValues != "") {
      //   window.open(
      //     "#/WHTC/" + this.year  + "/" + checkedValues.toString() + "/" + this.branch,
      //     "_blank"
      //   );
      // }
      // console.log(checkedValues);
    },
    viewallpdf() {
      console.log("value select", this.selected);
      window.open("#/WHTCALL/" + this.year + "/" + this.branch, "_blank");
    },
    // ดาวน์โหลด PDF ของพนักงานคนเดียว
    async downloadSinglePDF(item) {
      this.dialog_loading_WHT = true;
      console.log("item", item);
      var jsonperson = [];
      // เพิ่มข้อมูลพนักงาน 2 ครั้ง (ต้นฉบับ + สำเนา)
      jsonperson.push({
        emp_code: item.emp_code,
        id_card: item.id_card,
        emp_name: item.emp_name,
        payDate: item.payDate,
        address: item.address,
        social_pay: item.social_pay || 0,
        tax_number: item.tax_number || "",
        earning: item.earning || item.total_income,
        tax_pay: item.tax_pay || item.total_tax,
        total_income1: item.total_income1 || 0,
        total_income2: item.total_income2 || 0,
        total_tax1: item.total_tax1 || 0,
        total_tax2: item.total_tax2 || 0,
        total_balance: item.total_balance || item.tax_pay || item.total_tax,
      });
      jsonperson.push({
        emp_code: item.emp_code,
        id_card: item.id_card,
        emp_name: item.emp_name,
        payDate: item.payDate,
        address: item.address,
        social_pay: item.social_pay || 0,
        tax_number: item.tax_number || "",
        earning: item.earning || item.total_income,
        tax_pay: item.tax_pay || item.total_tax,
        total_income1: item.total_income1 || 0,
        total_income2: item.total_income2 || 0,
        total_tax1: item.total_tax1 || 0,
        total_tax2: item.total_tax2 || 0,
        total_balance: item.total_balance || item.tax_pay || item.total_tax,
      });

      try {
        await this.createSinglePDF(jsonperson);
        this.dialog_loading_WHT = false;
        this.snackbar = true;
        this.snackmsg = "สร้าง PDF เสร็จสิ้น";
        this.snackbarcolor = "success";
      } catch (err) {
        console.error(err);
        this.dialog_loading_WHT = false;
        this.snackbar = true;
        this.snackmsg = "เกิดข้อผิดพลาดในการสร้าง PDF";
        this.snackbarcolor = "error";
      }
    },
    // ดาวน์โหลด PDF ของพนักงานทั้งหมดที่แสดงในรายการ
    async downloadAllPDF() {
      var v = this;
      var jsonperson = [];
      this.zipLinks = [];
      this.dialog_loading_WHT = true;

      // ใช้ข้อมูลจาก newjson.details
      if (this.newjson.details && this.newjson.details.length > 0) {
        this.newjson.details.forEach((element) => {
          if (element.tax_pay > 0) {
            // เพิ่มข้อมูลพนักงาน 2 ครั้ง (ต้นฉบับ + สำเนา)
            jsonperson.push({
              emp_code: element.emp_code,
              id_card: element.id_card,
              emp_name: element.emp_name,
              payDate: element.payDate,
              address: element.address,
              social_pay: element.social_pay || 0,
              tax_number: element.tax_number || "",
              earning: element.earning || element.total_income,
              tax_pay: element.tax_pay || element.total_tax,
              total_income1: element.total_income1 || 0,
              total_income2: element.total_income2 || 0,
              total_tax1: element.total_tax1 || 0,
              total_tax2: element.total_tax2 || 0,
              total_balance: element.total_balance || element.tax_pay || element.total_tax,
            });
            jsonperson.push({
              emp_code: element.emp_code,
              id_card: element.id_card,
              emp_name: element.emp_name,
              payDate: element.payDate,
              address: element.address,
              social_pay: element.social_pay || 0,
              tax_number: element.tax_number || "",
              earning: element.earning || element.total_income,
              tax_pay: element.tax_pay || element.total_tax,
              total_income1: element.total_income1 || 0,
              total_income2: element.total_income2 || 0,
              total_tax1: element.total_tax1 || 0,
              total_tax2: element.total_tax2 || 0,
              total_balance: element.total_balance || element.tax_pay || element.total_tax,
            });
          }
        });

        if (jsonperson.length > 0) {
          this.pdf50(jsonperson);
        } else {
          this.snackbar = true;
          this.snackmsg = "ไม่มีข้อมูลที่มีภาษี";
          this.snackbarcolor = "error";
          this.dialog_loading_WHT = false;
        }
      } else {
        this.snackbar = true;
        this.snackmsg = "กรุณาโหลดข้อมูลก่อน";
        this.snackbarcolor = "error";
        this.dialog_loading_WHT = false;
      }
    },
    chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    },
    async createSinglePDF(jsonperson) {
      const url = "/static/pdf/approve_wh3_081156.pdf";
      const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
      const urlfont = "/static/THSarabunBold.ttf";
      const fontBytes = await fetch(urlfont).then((res) => res.arrayBuffer());

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const srcDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(fontBytes);

      // เพิ่มหน้าที่ 2 (สำเนา)
      const [copyPage] = await pdfDoc.copyPages(srcDoc, [0]);
      pdfDoc.addPage(copyPage);

      const pages = pdfDoc.getPages();

      // วาดทั้ง 2 หน้า (ต้นฉบับ + สำเนา)
      for (let pageIndex = 0; pageIndex < 2; pageIndex++) {
        const page = pages[pageIndex];
        const element = jsonperson[pageIndex];

        await this.drawPDFContent(page, element, customFont);
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const fileName = `รายการภาษีหักณที่จ่าย_${jsonperson[0].emp_name}.pdf`;

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async pdf50(jsonperson) {
      // console.log(jsonperson);
      jsonperson.sort((a, b) => a.emp_code.localeCompare(b.emp_code));

      const url = "/static/pdf/approve_wh3_081156.pdf";
      const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
      const urlfont = "/static/THSarabunBold.ttf";
      const fontBytes = await fetch(urlfont).then((res) => res.arrayBuffer());

      let v = this;

      // chunk ทีละ 2 หน้า (1 คน = 2 หน้า)
      const chunkSize = 2;
      const chunks = this.chunkArray(jsonperson, chunkSize);
      const zipChunkSize = 250; // 250 คน ต่อ zip (500 หน้า / 2)
      this.zipChunks = this.chunkArray(chunks, zipChunkSize);

      for (let i = 0; i < v.zipChunks.length; i++) {
        const zip = new JSZip();
        const zipChunk = v.zipChunks[i];

        for (let j = 0; j < zipChunk.length; j++) {
          const chunk = zipChunk[j];
          await this.downloadChunk(chunk, i * zipChunkSize + j, chunks.length - 1, existingPdfBytes, fontBytes, zip);
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipFileName = `WHT_${this.year}_part_${i + 1}.zip`;
        this.createDownloadLink(zipBlob, zipFileName);
      }

      this.dialog_loading_WHT = false;
      this.snackbar = true;
      this.snackmsg = "สร้าง PDF เสร็จสิ้น";
      this.snackbarcolor = "success";
    },
    async downloadChunk(chunk, idx, chunksSize, existingPdfBytes, fontBytes, zip) {
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const srcDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      let v = this;
      const customFont = await pdfDoc.embedFont(fontBytes);

      // เพิ่มหน้าที่ 2 (สำเนา)
      if (chunk.length > 1) {
        const [copyPage] = await pdfDoc.copyPages(srcDoc, [0]);
        pdfDoc.addPage(copyPage);
      }

      const pages = pdfDoc.getPages();

      // วาดข้อมูลในทั้ง 2 หน้า
      for (let index = 0; index < chunk.length; index++) {
        const element = chunk[index];
        const page = pages[index];

        await this.drawPDFContent(page, element, customFont);
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const fileName = `รายการภาษีหักณที่จ่าย_${chunk[0].emp_name}.pdf`;
      zip.file(fileName, blob);
    },
    async drawPDFContent(page, element, customFont) {
      // เลขที่
      if (element.tax_number) {
        page.drawText(element.tax_number, {
          x: 515,
          y: 768,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // เลขประจำตัวผู้เสียภาษีอากร (13 หลัก) - ของบริษัท
      if (this.taxpayer_number != null) {
        const positions = [378, 396, 408, 420, 432, 451, 462, 474, 486, 498, 517, 529, 548];
        for (let i = 0; i < 13 && i < this.taxpayer_number.length; i++) {
          page.drawText(this.taxpayer_number.substring(i, i + 1), {
            x: positions[i],
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
      }

      // ชื่อบริษัท
      if (this.companyName) {
        page.drawText(this.companyName, {
          x: 60,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // ที่อยู่บริษัท
      const companyAddress = `${this.companyhouse_no || ""} ตำบล ${this.companysubdistrict_subarea || ""} อำเภอ ${this.companydistrict_area || ""} จังหวัด ${this.companyprovince ||
        ""} ${this.companypostcode || ""}`;
      page.drawText(companyAddress, {
        x: 60,
        y: 708,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });

      // เลขประจำตัวผู้เสียภาษีอากร (ผู้ถูกหัก 13 หลัก)
      if (element.id_card) {
        const positions = [379, 397, 408, 420, 432, 451, 463, 475, 487, 499, 517, 529, 548];
        for (let i = 0; i < 13 && i < element.id_card.length; i++) {
          page.drawText(element.id_card.substring(i, i + 1), {
            x: positions[i],
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
      }

      // ชื่อ-นามสกุล พนักงาน
      page.drawText(element.emp_name || "", {
        x: 60,
        y: 660,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });

      // ที่อยู่พนักงาน
      page.drawText(element.address || "", {
        x: 60,
        y: 633,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });

      // วันที่จ่าย และ total_income1, total_tax1
      if (element.payDate && element.total_income1 > 0) {
        const date = moment(element.payDate).format("DD/MM/YYYY");
        page.drawText(date, {
          x: 350,
          y: 535,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        // เงินเดือน (total_income1)
        const earning = this.thousandSep(element.total_income1).split(".");
        const earningXPos = this.calculateTextPosition(earning[0]);
        page.drawText(earning[0], {
          x: earningXPos,
          y: 535,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (earning[1] === undefined) {
          earning[1] = "00";
        }
        page.drawText("." + earning[1], {
          x: 475,
          y: 535,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        // ภาษี (total_tax1)
        const tax = this.thousandSep(element.total_tax1).split(".");
        const taxXPos = this.calculateTaxPosition(tax[0]);
        page.drawText(tax[0], {
          x: taxXPos,
          y: 535,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (tax[1] === undefined) {
          tax[1] = "00";
        }
        page.drawText("." + tax[1], {
          x: 547,
          y: 535,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // วันที่จ่าย และ total_income2, total_tax2
      if (element.payDate && element.total_income2 > 0) {
        const date = moment(element.payDate).format("DD/MM/YYYY");
        page.drawText(date, {
          x: 350,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        // เงินเดือน (total_income2)
        const earning = this.thousandSep(element.total_income2).split(".");
        const earningXPos = this.calculateTextPosition(earning[0]);
        page.drawText(earning[0], {
          x: earningXPos,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (earning[1] === undefined) {
          earning[1] = "00";
        }
        page.drawText("." + earning[1], {
          x: 475,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        // ภาษี (total_tax2)
        const tax = this.thousandSep(element.total_tax2).split(".");
        const taxXPos = this.calculateTaxPosition(tax[0]);
        page.drawText(tax[0], {
          x: taxXPos,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (tax[1] === undefined) {
          tax[1] = "00";
        }
        page.drawText("." + tax[1], {
          x: 547,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // เงินเดือนรวม (earning)
      if (element.earning) {
        const earning = this.thousandSep(element.earning).split(".");
        const xPos = this.calculateTextPosition(earning[0]);
        page.drawText(earning[0], {
          x: xPos,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (earning[1] === undefined) {
          earning[1] = "00";
        }
        page.drawText("." + earning[1], {
          x: 475,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // ภาษีรวม (tax_pay)
      if (element.tax_pay) {
        const tax = this.thousandSep(element.tax_pay).split(".");
        const xPos = this.calculateTaxPosition(tax[0]);
        page.drawText(tax[0], {
          x: xPos,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        if (tax[1] === undefined) {
          tax[1] = "00";
        }
        page.drawText("." + tax[1], {
          x: 547,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // ภาษีเป็นตัวอักษร
      if (element.tax_pay) {
        this.tax = this.formatNumber(element.tax_pay);
        this.ArabicNumberToText(this.tax);
        page.drawText(this.texttax, {
          x: 250,
          y: 160,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // ประกันสังคม
      if (element.social_pay) {
        page.drawText("" + element.social_pay, {
          x: 370,
          y: 145,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      // เครื่องหมาย X ที่ช่องประกันสังคม
      page.drawText("X", {
        x: 85,
        y: 122,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });
    },
    calculateTextPosition(text) {
      const length = text.length;
      console.log("length:", length);
      let base = 475; // default for length < 4

      if (length >= 4) base = 483;
      if (length >= 9) base = 493;
      if (length >= 12) base = 507;
      if (length >= 15) base = 525;
      if (length >= 17) base = 528;
      if (length >= 21) base = 540;

      return base - 6 * length;
    },
    calculateTaxPosition(text) {
      const length = text.length;
      if (length >= 13) {
        return 515 - 5 * (length - 4) - length;
      } else if (length >= 9) {
        return 515 - 5 * (length - 3) - length;
      } else if (length >= 4) {
        return 540 - 5 * (length - 2) - length;
      } else {
        return 540 - 5 * (length - 1) - length;
      }
    },
    async getCopyDoc(pdfDoc, PDFDocument, existingPdfBytes, srcDoc) {
      const [existingPage] = await pdfDoc.copyPages(srcDoc, [0]);
      return [existingPage];
    },
    createDownloadLink(blob, fileName) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    CheckNumber(Number) {
      var NumberStr = Number.toString();
      NumberStr = NumberStr.replace(/ |,|บาท|฿/gi, "");
      for (var i = 0; i < NumberStr.length; i++) {
        if (
          NumberStr.charAt(i) != "0" &&
          NumberStr.charAt(i) != "1" &&
          NumberStr.charAt(i) != "2" &&
          NumberStr.charAt(i) != "3" &&
          NumberStr.charAt(i) != "4" &&
          NumberStr.charAt(i) != "5" &&
          NumberStr.charAt(i) != "6" &&
          NumberStr.charAt(i) != "7" &&
          NumberStr.charAt(i) != "8" &&
          NumberStr.charAt(i) != "9" &&
          NumberStr.charAt(i) != "."
        ) {
          return false;
        }
      }
      return NumberStr;
    },
    ArabicNumberToText(Number) {
      var Number = this.CheckNumber(Number);
      var NumberArray = new Array("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
      var DigitArray = new Array("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
      var BahtText = "";
      if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        if (Number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          Number = Number.split(".");
          if (Number[1] && Number[1].length > 0) {
            Number[1] = Number[1].substring(0, 2);
          }
          var NumberLen = Number[0].length - 0;
          for (var i = 0; i < NumberLen; i++) {
            var tmp = Number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ยี่";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += NumberArray[tmp];
              }
              BahtText += DigitArray[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (!Number[1] || Number[1] == "0" || Number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            var DecimalLen = Number[1].length - 0;
            for (var i = 0; i < DecimalLen; i++) {
              var tmp = Number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ยี่";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += NumberArray[tmp];
                }
                BahtText += DigitArray[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          this.texttax = BahtText;
          return BahtText;
        }
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}
#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  display: block;
}
table,
td,
th {
  border: 1px solid black;
  height: 40px;
  font-size: 16px;
}
th {
  background-color: #067ce2 !important;
  color: #ffff !important;
  font-size: 16px !important;
}
.topic-color {
  background-color: #64b5f6;
  color: #ffff;
}
.v-card_text {
  padding: 20px 20px 20px 25px !important;
  width: 100%;
}
.text-tax {
  color: red;
  font-weight: 400;
  padding-left: 1px;
}
.text-salary {
  color: green;
  font-weight: 400;
  padding-left: 1px;
}
</style>
